/**
 * jsonp 工具函数
 * @param {string} url - 请求 URL
 * @param {object} params - 请求参数
 * @param {number} timeout - 超时时间，默认 10000ms
 * @returns {Promise} - 返回 Promise
 */
export default function jsonp(url, params = {}, timeout = 10000) {
  return new Promise((resolve, reject) => {
    // 创建一个唯一的回调函数名称
    const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    // 设置回调函数
    window[callbackName] = function (data) {
      delete window[callbackName];
      document.body.removeChild(script);
      if (data) {
        resolve(data);
      } else {
        reject(new Error('JSONP 请求失败'));
      }
    };

    // 添加回调参数
    params.callback = callbackName;

    // 构建完整的 URL
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    const fullUrl = url + (url.includes('?') ? '&' : '?') + queryString;

    // 创建 script 标签
    const script = document.createElement('script');
    script.src = fullUrl;
    script.onerror = () => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('JSONP 请求错误'));
    };

    // 设置超时处理
    const timeoutId = setTimeout(() => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('JSONP 请求超时'));
    }, timeout);

    // 在成功回调中清除超时
    const originalCallback = window[callbackName];
    window[callbackName] = function (data) {
      clearTimeout(timeoutId);
      originalCallback(data);
    };

    // 添加到 body
    document.body.appendChild(script);
  });
} 